import { css } from "@emotion/react";
import { SwarovskiLink } from "../../components/_shared-components/ui-elements/SwarovskiLink";
import { CSS_MQ } from "../../styles/breakpoints";
import { FONTS, fontSize } from "../../styles/fonts";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";

type PDPBreadcrumbsProps = {
  data: Array<{
    label: string;
    path: string | undefined;
    search: string | undefined;
  }>;
};

export const PDPBreadcrumbs: ReactTFC<PDPBreadcrumbsProps> = props => {
  return (
    <div
      css={css`
        display: none;

        ${CSS_MQ.atLeastSm} {
          display: flex;
          --g: 40px;

          gap: var(--g);

          margin-bottom: 8px;
        }
      `}
    >
      {props.data.map(b => {
        const Content = (
          <span
            css={[
              FONTS.SwarovskiFutura300,
              fontSize.x2,
              css`
                line-height: 1.1;
                color: black;
              `,
            ]}
          >
            {b.label}
          </span>
        );

        return (
          <span key={JSON.stringify(b)} css={attachStyles}>
            {b.path ? (
              <SwarovskiLink
                link={{
                  pathname: b.path,
                  search: b.search,
                }}
                isInternal={true}
                styled={"no-decoration"}
                scrollToTop={true}
              >
                {Content}
              </SwarovskiLink>
            ) : (
              <span>{Content}</span>
            )}
          </span>
        );
      })}
    </div>
  );
};

const attachStyles = [
  FONTS.SwarovskiFutura300,
  css`
    color: black;

    position: relative;

    display: flex;
    align-items: center;

    &:not(:first-of-type):before {
      position: absolute;
      left: calc(var(--g) * -0.5 - 0.25em);
      content: ">";
      top: 50%;
      transform: translateY(-50%);
    }
  `,
];
